import {OperationVariables, SuspenseQueryHookOptions, useSuspenseQuery} from "@apollo/client";
import {TypedDocumentNode} from "@graphql-typed-document-node/core";
import {useEffect} from "react";

export function useAutoThrowSuspenseQuery<TData = unknown, TVariables extends OperationVariables = OperationVariables>(
  query: TypedDocumentNode<TData, TVariables>,
  options?: SuspenseQueryHookOptions<TData, TVariables>
) {
  const result = useSuspenseQuery<TData, TVariables>(query, options);

  // Throw the error to be caught by the error boundary on page load
  useEffect(() => {
    if (result.error) {
      throw result.error;
    }
  }, [result.error]);

  return result;
}
